export default {
  conf: {
    wechatCode: '微信编号',
    wechatName: '微信名称',
    appId: '开发者ID',
    appSecret: '开发者秘钥',
    Token: '令牌',
    encodeAesKey: '消息加解密秘钥',
    messageEncrypt: '消息加密方式',
    accessToken: '访问令牌',
    JSAPITICKET: 'JSAPITICKET',
    domain: '域名',
    refreshTime: '刷新时间',
    mchId: '商户ID',
    payKey: '支付key',
    certificatePath: '证书路径',
    certificateKey: '证书key',
    showUrlConf: '显示url配置',
    ayncUsers: '同步用户'
  }

}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/wechat/conf.js